var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandardVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 9.44444L20.3922 6.91556C20.5616 6.83093 20.7498 6.79098 20.9389 6.7995C21.128 6.80801 21.3118 6.86472 21.4729 6.96423C21.634 7.06374 21.7669 7.20275 21.8592 7.36808C21.9514 7.53341 21.9999 7.71957 22 7.90889V15.4244C21.9999 15.6138 21.9514 15.7999 21.8592 15.9653C21.7669 16.1306 21.634 16.2696 21.4729 16.3691C21.3118 16.4686 21.128 16.5253 20.9389 16.5338C20.7498 16.5424 20.5616 16.5024 20.3922 16.4178L15.3333 13.8889V9.44444ZM2 7.22222C2 6.63285 2.23413 6.06762 2.65087 5.65087C3.06762 5.23413 3.63285 5 4.22222 5H13.1111C13.7005 5 14.2657 5.23413 14.6825 5.65087C15.0992 6.06762 15.3333 6.63285 15.3333 7.22222V16.1111C15.3333 16.7005 15.0992 17.2657 14.6825 17.6825C14.2657 18.0992 13.7005 18.3333 13.1111 18.3333H4.22222C3.63285 18.3333 3.06762 18.0992 2.65087 17.6825C2.23413 17.2657 2 16.7005 2 16.1111V7.22222Z",
    stroke: "#1C1356",
    strokeWidth: 2.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardVideo);
export default __webpack_public_path__ + "static/media/standard-video.da65e5d0.svg";
export { ForwardRef as ReactComponent };